module.exports = __webpack_public_path__ + "build/img/5.adb294a0.png";